
import { useFormikContext, Field } from "formik";
import { useFormikWizard } from "formik-wizard";
import React from "react";

function Property() {
    const { } = useFormikContext();
    const formik = useFormikWizard();

    const [showResults, setShowResults] = React.useState(false)
    const onClick = () => setShowResults(true)
    const hideResult = () => setShowResults(false)

   

  return (
    <div>
      <h2 class="heading1">Property</h2>
      <p>Assessments for residential care may include the value of your home. Answer the following questions to work out whether this will be the case. </p>
      { (formik.values.valuecare.ownproperty === "1") &&
       <div>
       <fieldset>
       <label class="mbottom-10 heading3" htmlFor="propertyvalue">What is the current approximate value of your home?</label>
       <div class="">
           <div class="form__control">
               <span class="inline pound-font">£</span>
               <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$"  id="propertyvalue" name="propertyvalue" class="input-width--300"/>
           </div>
       </div>
     </fieldset>
     <fieldset class="question-section">
       <legend class="heading3 mbottom-10">Do you have a mortgage or loan secured against your home?</legend>
       <div>
           <div class="form-group form__control">
               <div class=" form__radio form__control form__control--clear">
                   <Field type="radio" id="mortgageloan_yes" name="mortgageloan"  value="1" onClick={onClick}/>
                   <label class="form__label" htmlFor="mortgageloan_yes"><span>Yes</span></label>
               </div>
               { showResults &&
               
               <div class="radio__reveal">
                   <div class="form-group form__control">
                       <label for="mortgageloanamountvalue" class="heading3" htmlFor="mortgageloanamountvalue">How much is the mortgage or loan?</label>
                       <div class="form__control">
                           <span class="inline pound-font">£</span> 
                           <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$"  id="mortgageloanamountvalue" name="mortgageloanamountvalue" class="input-width--300"/>
                       </div>
                   </div>
               </div>
               }
           </div>
           <div class="form__radio form__control">
               <Field type="radio" id="mortgageloan_no" name="mortgageloan" value="0" onClick={hideResult}/>
               <label class="form__label" htmlFor="mortgageloan_no"> <span>No</span></label>
           </div>
       </div>
   </fieldset>

   <fieldset className="question-section">
       <label htmlFor="totalinhome" className="heading3 mbottom-10">How many people in total (including you) own this home?</label>
       <div className="form__radio form__control">
           <Field type="text" inputmode="numeric" pattern="[0-9]*" id="totalinhome" name="totalinhome" class="input-width--100" />
       </div>
   </fieldset>


   </div>
      
      }
    <fieldset class="question-section" data-togglefieldsetfrom="ownproperty" data-togglefieldsetdisplay="0">
        <label for="totalinhome" class="heading3 mbottom-10" htmlFor="totalinhome">How many people in total (including you) own this home?</label>
        <div class="form__radio form__control">
                <Field type="text" inputmode="numeric" pattern="[0-9]*"  id="totalinhome" name="totalinhome" class="input-width--100" />
            </div>
    </fieldset>

    <fieldset class="question-section">
        <legend class="heading3 mbottom-0">Do any of the following apply?</legend>
        <ul class="mtop-10">
            <li>my partner lives at this address</li>
            <li>I have dependent children under the age of 18 living at this address</li>
            <li>a relative of pensionable age lives at this address</li>
            <li>a relative who is receiving disability benefits lives at this address</li>
            <li>a relative who has been my carer lives at this address</li>
            <li>a relative who considers this address to be their sole or main residence lives at this address</li>
        </ul>
        <div class="form__control form__radio">
            <Field type="radio" id="followingapply_yes" name="followingapply" value="1"/>
            <label class="form__label" htmlFor="followingapply_yes"><span>Yes</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="followingapply_no" name="followingapply" value="0"/>
            <label class="form__label" htmlFor="followingapply_no"><span>No</span></label>
        </div>
    </fieldset>
        
    </div>
  );
}
export default Property;